// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Require environment variables - no hardcoded fallback to prevent using wrong database
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || import.meta.env.VITE_SUPABASE_ANON_KEY;

// Detect if we're in production build
const isProduction = import.meta.env.MODE === 'production' || import.meta.env.PROD;

// Validate configuration - fail loudly if missing
if (!SUPABASE_URL) {
  const errorMsg = isProduction
    ? 'Database connection error: Missing VITE_SUPABASE_URL. This must be set during the build process. Please ensure environment variables are configured in your deployment platform (CI/CD, hosting service, etc.) before building.'
    : 'Missing VITE_SUPABASE_URL environment variable. Please set it in your .env file.';
  console.error('❌', errorMsg);
  console.error('💡 Tip: Vite embeds environment variables at build time. Make sure your .env file exists and contains VITE_SUPABASE_URL before running npm run build.');
  throw new Error(errorMsg);
}

if (!SUPABASE_PUBLISHABLE_KEY) {
  const errorMsg = isProduction
    ? 'Database connection error: Missing VITE_SUPABASE_PUBLISHABLE_KEY or VITE_SUPABASE_ANON_KEY. This must be set during the build process. Please ensure environment variables are configured in your deployment platform before building.'
    : 'Missing VITE_SUPABASE_PUBLISHABLE_KEY or VITE_SUPABASE_ANON_KEY environment variable. Please set it in your .env file.';
  console.error('❌', errorMsg);
  console.error('💡 Tip: Vite embeds environment variables at build time. Make sure your .env file exists and contains VITE_SUPABASE_PUBLISHABLE_KEY or VITE_SUPABASE_ANON_KEY before running npm run build.');
  throw new Error(errorMsg);
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY || '', {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    // Use default Supabase locking (no custom lock) to avoid stale state
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
    // Send heartbeat every 30 seconds to keep connection alive during idle periods
    heartbeatIntervalMs: 30000,
    // Reconnect after 10 seconds if connection is lost
    reconnectAfterMs: (tries: number) => {
      // Exponential backoff: 1s, 2s, 4s, 8s, max 10s
      return Math.min(1000 * Math.pow(2, tries), 10000);
    },
  },
});
